import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeProvider } from 'styled-components';
import ErrorBoundary from '../../../shared/error-boundary';
import commonProps from '../common/common-props';
import FeatureControl from './feature-control';
import Header from './common/header';
import { Link } from './common/styles';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const SmallLink = styled(Link)`
  font-size: 14px;
`;

const Separator = styled.div`
  height: 0px;
  border-bottom: 1px solid ${props => props.theme.secondaryColorLight};
  margin-top: 20px;
  margin-bottom: 20px;
`;

export default function ProfileFeaturesAdmin(props) {
  const common = commonProps();
  const { profile, availableFeatures } = props;
  return (
    <ThemeProvider theme={common}>
      <ErrorBoundary>
        <Header type="features" profile={profile} />
        {profile.showProfileLink && <SmallLink href={`/contributors/${profile.slug}`}>Profile Page</SmallLink>}
        <Separator />
        <Container>
          {availableFeatures.map(feature => (
            <React.Fragment>
              <FeatureControl
                key={feature}
                profileId={profile.id}
                feature={feature}
                profileFeature={_.find(profile.features, ['feature', feature]) || null}
              />
              <Separator />
            </React.Fragment>
          ))}
        </Container>
      </ErrorBoundary>
    </ThemeProvider>
  );
}

/* eslint-disable react/no-unused-prop-types */
ProfileFeaturesAdmin.propTypes = {
  profile: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    slug: PropTypes.string,
    organization: PropTypes.string,
    position: PropTypes.string,
    showProfileLink: PropTypes.bool,
    features: PropTypes.arrayOf(PropTypes.shape({
      feature: PropTypes.string,
      active: PropTypes.bool,
    })),
  }).isRequired,
  availableFeatures: PropTypes.arrayOf(PropTypes.string),
};
/* eslint-enable react/no-unused-prop-types */
ProfileFeaturesAdmin.defaultProps = {
  availableFeatures: [],
};
